import { Avatar, Card, CardContent, CardHeader, Chip, Divider, Grid, IconButton, Tooltip, Typography, } from "@material-ui/core";
import { Link } from "@material-ui/icons";
import { Skeleton } from "@material-ui/lab";
import React from "react";
import { useFieldLookup } from "../../../hooks/useFieldLookup";
import { usersCachingService } from "../../../services";
import { userRendererStyles } from "./useRendererStyles";
export const CaseAllocationTile = ({ tile, navigate }) => {
    const classes = userRendererStyles();
    const getColorClass = (lowerLimit, upperLimit, value) => {
        if (value <= lowerLimit) {
            return classes.green;
        }
        if (value > lowerLimit && value < upperLimit) {
            return classes.amber;
        }
        if (value >= upperLimit) {
            return classes.red;
        }
    };
    const getChips = (groups, type) => {
        const group = groups.find((x) => x.name === type);
        const findValue = (type) => { var _a; return group ? ((_a = group.data.find((x) => x.title === type)) === null || _a === void 0 ? void 0 : _a.value) || 0 : 0; };
        return (React.createElement(React.Fragment, null,
            React.createElement(Grid, { item: true, xs: 3 },
                React.createElement(Chip, { label: findValue("OPEN"), size: "small", className: `${classes.chip} ${getColorClass(tile.lowerLimit || 0, tile.upperLimit || 10, findValue("OPEN"))}` })),
            React.createElement(Grid, { item: true, xs: 3 },
                React.createElement(Chip, { label: findValue("ABOUT_TO_BREACH"), size: "small", className: `${classes.chip} ${getColorClass(tile.lowerLimit || 0, tile.upperLimit || 10, findValue("ABOUT_TO_BREACH"))}` })),
            React.createElement(Grid, { item: true, xs: 3 },
                React.createElement(Chip, { label: findValue("BREACHED"), size: "small", className: `${classes.chip} ${getColorClass(tile.lowerLimit || 0, tile.upperLimit || 10, findValue("BREACHED"))}` }))));
    };
    const createdByName = useFieldLookup(usersCachingService, tile.title);
    return createdByName ? (React.createElement(Grid, { item: true, xs: 12 },
        React.createElement(Card, { className: classes.root },
            React.createElement(CardHeader, { action: React.createElement(Tooltip, { title: `View list of cases for ${tile.title}` },
                    React.createElement(IconButton, { onClick: () => navigate && navigate(tile.filterUrl) },
                        React.createElement(Link, { style: { fill: "currentcolor" } }))), avatar: React.createElement(Avatar, null), title: React.createElement(Typography, { variant: "body1", className: classes.cardHeading }, createdByName), className: classes.header }),
            React.createElement(Divider, null),
            React.createElement(CardContent, { className: classes.cardContent },
                React.createElement(Grid, { container: true, spacing: 2 },
                    React.createElement(Grid, { item: true, xs: 3 }),
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(Typography, { variant: "caption", className: classes.countCaption }, "Open")),
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(Typography, { variant: "caption", className: classes.countCaption }, "About to breach")),
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(Typography, { variant: "caption", className: classes.countCaption }, "Breached")),
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(Typography, { variant: "caption", className: classes.countCaption }, "Complaint to Ofqual")),
                    getChips(tile.groups, "complaintToOfqual"),
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(Typography, { variant: "caption", className: classes.countCaption }, "Complaint about Ofqual")),
                    getChips(tile.groups, "complaintAboutOfqual"),
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(Typography, { variant: "caption", className: classes.countCaption }, "Malpractice")),
                    getChips(tile.groups, "malpractice"),
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(Typography, { variant: "caption", className: classes.countCaption }, "Whistleblower")),
                    getChips(tile.groups, "whistleblower"),
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(Typography, { variant: "caption", className: classes.countCaption }, "Executive Policy")),
                    getChips(tile.groups, "executivePolicy"),
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(Typography, { variant: "caption", className: classes.countCaption }, "Executive Complaint")),
                    getChips(tile.groups, "executiveComplaint")))))) : (React.createElement(Grid, { item: true, xs: 12 },
        React.createElement(Skeleton, { variant: "text", height: 60 }),
        React.createElement(Skeleton, { variant: "text", height: 60 }),
        React.createElement(Skeleton, { variant: "text", height: 60 })));
};
